import { CallOutAlertVariant, } from '../../../../../../components/callOutAlert/types/callOutAlertTheme';
import { commonStyles, containersCommonStyles } from '../commonStyles';
export const getIllustrationtStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CallOutAlertVariant.ILLUSTRATION]: {
            ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS),
            ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            illustrationContainer: {
                border_radius: FOUNDATIONS.radius_1000,
            },
            illustration: {
                width: FOUNDATIONS.size_450,
                height: FOUNDATIONS.size_450,
            },
        },
    };
};
//# sourceMappingURL=illustration.js.map